import compositions from '@/store/modules/audiences/composition';
import integrations from '@/store/modules/audiences/integrations';
import historic from '@/store/modules/audiences/historic';
import base from '@/store/modules/audiences/base';
import exportation from '@/store/modules/audiences/exportation';
const modules = [base, compositions, integrations, historic, exportation];
function deepMergeModules(modules) {
    const result = {
        state: {},
        getters: {},
        actions: {},
        mutations: {},
    };
    for (const module of modules) {
        const state = typeof module.state === 'function' ? module.state() : module.state;
        Object.assign(result.state, structuredClone(state || {}));
        Object.assign(result.getters, module.getters || {});
        Object.assign(result.actions, module.actions || {});
        Object.assign(result.mutations, module.mutations || {});
    }
    return result;
}
const merged = deepMergeModules(modules);
export default {
    namespaced: true,
    ...merged,
};
